module.exports = __webpack_public_path__ + "img/notification1.6d2b3566.svg";